import BaseListPresenter from "../../../../base/BaseListPresenter";
import { formatDate } from "../../../../components/common/Converter";
import {
  findObjectUseCase,
  getObjectUseCase,
} from "../../../../usecases/object";

class MainpageNoticePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  async componentDidMount() {
    const fields = [
      "region",
      "office",
      "division",
      "section",
      "unit",
      "cluster",
    ];

    const fieldNameMap = {
      cluster: "plantilla",
      region: "regions",
      office: "offices",
      division: "divisions",
      section: "sections",
      unit: "units",
    };

    const employeeID = this.view.getCurrentUser().employee;
    const employee = await getObjectUseCase().execute(
      "employees",
      employeeID.id,
      {
        params: {
          select: [
            "region",
            "office",
            "division",
            "section",
            "unit",
            "cluster",
          ],
        },
      },
    );
    if (!employee) return;
    const lastNonEmptyField = fields
      ?.slice()
      .reverse()
      .find((field) => employee[field]);

    const mappedField = lastNonEmptyField
      ? fieldNameMap[lastNonEmptyField] || lastNonEmptyField
      : null;

    const lastNonEmptyValue = lastNonEmptyField
      ? employee[lastNonEmptyField]
      : null;

    const mapped = lastNonEmptyValue
      ? { [mappedField]: lastNonEmptyValue }
      : { cluster: undefined };

    // console.log("mapped: ", mapped);

    const noticeQuery = {
      where: {
        $or: [
          {
            ...mapped,
          },
          { "employees.id": employeeID.id },
          { sendToAll: true },
        ],
      },
      sort: { createdAt: -1 },
    };

    const date = formatDate(new Date());
    const empID = this.view.getCurrentUser().id;
    const recentActQuery = {
      where: {
        userId: empID,
        createdAt: { $gte: date },
      },
      sort: { createdAt: -1 },
    };
    const notices = await findObjectUseCase().execute("notices", noticeQuery);
    const recentAct = await findObjectUseCase().execute(
      "audit_logs",
      recentActQuery,
    );
    this.view.setState({ notices, recentAct });
  }
}
export default MainpageNoticePresenter;
